export default __webpack_public_path__ + "static/media/main-img2.325c2171.png";